import Home from "../page/home/home";
import { Route, Routes, BrowserRouter } from "react-router-dom";
import Shop from "../page/shop/shop";
import Category from "../page/category/category";
import "../Components/style/responsive.css";
import MainNavbar from "../Components/Header/Navbar/MainNavbar";
import Main from "../Components/fotter/Main";
import AboutUs from "../Components/page/Aboutus/AboutUs";
import ContactUs from "../Components/page/contactus/ContactUs";

function MainNavigator() {

  return (
    <BrowserRouter>
      <MainNavbar />
      <Routes>
        <Route path="/shop" element={<Shop />} />
        <Route path="/category" element={<Category />} />
        <Route path="/" element={<Home />} />
        <Route path="/About-us" element={<AboutUs />} />
        <Route path="/Contact-us" element={<ContactUs />} />
      </Routes>
      <Main />
    </BrowserRouter>
  );
}

export default MainNavigator;

